import React from 'react';
import { useNavigate } from 'react-router-dom';
import iconBack from '../../../../images/icon-chevron-left.svg';
import styles from '../LocationsForNewLocationAvailability.module.css';

interface LocationsHeaderProps {
    type: string;
}

/**
 * Header component for Locations Selection Page
 * Provides navigation back to visits page and displays appropriate title
 */
const LocationsHeader: React.FC<LocationsHeaderProps> = ({ type }) => {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate('/visits');
    };

    const title = type === 'add-availability' ? 'Add Availability' : 'Make Unit Unavailable';

    return (
        <div className={styles.inlineItems}>
            <div className={styles.leftSection}>
                <div 
                    onClick={handleBackClick} 
                    className={styles.backButton}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            handleBackClick();
                        }
                    }}
                    aria-label="Go back to visits"
                >
                    <img src={iconBack} alt="back icon" />
                </div>
                <h2>{title}</h2>
            </div>
        </div>
    );
};

export default LocationsHeader;

